var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row search-bar-wrapper"},[_c('Searchbar'),_c('MapTableSwitch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }